import { format } from "date-fns";
import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ExpensesTab } from "./tabs/ExpensesTab";
import { RevenuesTab } from "./tabs/RevenuesTab";
import { ValidatedRevenuesTab } from "./tabs/ValidatedRevenuesTab";
import { ProfitComparisonSection } from "./sections/ProfitComparisonSection";

export const BudgetDashboard = () => {
  const handleExportCSV = () => {
    const data = window.localStorage.getItem("transactions_summary");
    if (!data) return;

    const parsedData = JSON.parse(data);
    const headers = ["Date", "Montant"];
    const rows = parsedData.map((row: any) => [
      row.date,
      row.amount.toString()
    ]);

    const csvContent = [
      headers.join(","),
      ...rows.map(row => row.join(","))
    ].join("\n");

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", `budget_${format(new Date(), 'yyyy-MM')}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const formatCurrency = (amount: number) => {
    return `${amount.toLocaleString()} FCFA`;
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold">Tableau de bord financier</h2>
        <Button onClick={handleExportCSV} variant="outline" size="sm">
          <Download className="w-4 h-4 mr-2" />
          Exporter CSV
        </Button>
      </div>

      <ProfitComparisonSection formatCurrency={formatCurrency} />

      <Tabs defaultValue="revenues" className="space-y-6">
        <TabsList>
          <TabsTrigger value="revenues">Revenus</TabsTrigger>
          <TabsTrigger value="validated_revenues">Chiffre d'affaires validé</TabsTrigger>
          <TabsTrigger value="expenses">Dépenses</TabsTrigger>
        </TabsList>

        <TabsContent value="revenues">
          <RevenuesTab />
        </TabsContent>

        <TabsContent value="validated_revenues">
          <ValidatedRevenuesTab />
        </TabsContent>

        <TabsContent value="expenses">
          <ExpensesTab />
        </TabsContent>
      </Tabs>
    </div>
  );
};